import https from "./https";
import store from "@/store";

const organization = store.state.general.organization;

const bookingPreset = {
  // 預約設定檔 booking_presets
  async getStaffs(id, params = {}) {
    let { data } = await https.get(
      `admin/organizations/${organization.id}/booking-presets/${id}/staffs`, {
        params
      }
    );
    return data.data;
  },
}

export default bookingPreset;
